export const ENV = {
  ENABLE_FAKE_DATA: import.meta.env.VITE_ENABLE_FAKE_DATA,
  GA_TRACKING_ID: import.meta.env.VITE_GA_TRACKING_ID,
}
